export default "__VITE_ASSET__Cm5bZoT___ 640w, __VITE_ASSET__B5LINDLS__ 1024w, __VITE_ASSET__BzvKJOIB__ 1920w";